/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * CartService APIs
 */

import addToCart from './addToCart';
import getCartOrderDetails from './getCartOrderDetails';
import donation from './donation';
import deleteCart from './deleteCart';
import deleteCartItem from './deleteCartItem';
import deleteViewTime from './deleteViewTime';
import duplicateCartItem from './duplicateCartItem';
import updateCartItemQuantity from './updateCartItemQuantity';
import validateCart from './validateCart';
import calculateCart from './calculateCart';
import cartCount from './cartCount';
import getCartNoId from './getCartNoId';
import saveRecipient from './saveRecipient';
import addGreetingCard from './generateGreetingCard';
import addPassportToCart from './addPassportToCart';
import addProductPersonalization from './addProductPersonalization';
import applyPromotion from './applyPromotion';
import recordAttributions from './recordAttributions';
import saveGreetingMessage from './saveGreetingMessage';
import saveRecipientNoCartId from './saveRecipientNoCartId';
import expressCheckout from './expressCheckout';
import calculateDynamicPassport from './calculateDynamicPassport';
import getDeliveryTime from './getDeliveryTime';
import displayCalendar from './displayCalendar';
import displayViewTime from './displayViewTime';
import getShippingMethods from './getShippingMethods';
import updateAttribute from './updateAttribute';
import addUpsell from './addUpsell';
import setBillingAddress from './setBillingAddress';
import updateCartItemDeliveryInfo from './updateCartItemDeliveryInfo';
import updatePersonalization from './updatePersonalizationLines';
import editRecipient from './editRecipient';
import prepareCart from './prepareCart';
import updateDeliveryTime from './updateDeliveryTime';
import removeGiftCard from './removeGiftCard';
import getPaymentCommonClientToken from './getPaymentCommonClientToken';
import getPayment from './getPayment';
import giftCard from './giftCard';
import initPayment from './initPayment';
import paypalPaymentToken from './paypalPaymentToken';
import paypalClientToken from './paypalClientToken';
import processVisaCheckoutData from './processVisaCheckoutData';
import availablityDeliveryCalendar from './availablityDeliveryCalendar';
import findOrderDetailsByUser from './findOrderDetailsByUser';
import findOrderDetailsByMember from './findOrderDetailsByMember';
import findOrderStatusByUser from './findOrderStatusByUser';
import mergeCart from './mergeCart';
import getCartCount from './getCartCount';

export default {
    addToCart,
    donation,
    deleteCart,
    deleteCartItem,
    deleteViewTime,
    duplicateCartItem,
    getCartOrderDetails,
    validateCart,
    calculateCart,
    updateCartItemQuantity,
    cartCount,
    getCartNoId,
    saveRecipient,
    addGreetingCard,
    addPassportToCart,
    addProductPersonalization,
    applyPromotion,
    recordAttributions,
    saveGreetingMessage,
    saveRecipientNoCartId,
    expressCheckout,
    calculateDynamicPassport,
    getDeliveryTime,
    displayCalendar,
    displayViewTime,
    getShippingMethods,
    updateAttribute,
    addUpsell,
    setBillingAddress,
    updateCartItemDeliveryInfo,
    updatePersonalization,
    editRecipient,
    prepareCart,
    updateDeliveryTime,
    removeGiftCard,
    getPaymentCommonClientToken,
    getPayment,
    giftCard,
    initPayment,
    paypalPaymentToken,
    paypalClientToken,
    processVisaCheckoutData,
    availablityDeliveryCalendar,
    findOrderDetailsByUser,
    findOrderDetailsByMember,
    findOrderStatusByUser,
    mergeCart,
    getCartCount,
};
